module.exports = __webpack_public_path__ + "static/media/amusement(24).2873817e.PNG";